/**
 * 出价时间去掉年月日
 */
export const formatBidTime = (datetime?: string) => {
  if (!datetime) return ''

  const parts = datetime?.split(' ')

  return `${parts[1]} ${parts[2]}`
}
